import { useRef } from 'react';

const PAN_THRESHOLD = 4; // px

/**
 * Перетаскивание полотна мышью. Отдаёт обработчики указателя для доски.
 *
 * Пан начинается только на пустом месте графика: слой связей накрывает всю область
 * чарта, а бары лежат поверх него, поэтому попадание в .wx-links и означает «мимо бара».
 */
const useChartPan = ({ apiRef, boardRef }) => {
  const panRef = useRef(null); // состояние текущего свайпа

  const onPointerDown = (e) => {
    if (e.button !== 0 || !apiRef.current) return;
    if (e.target.closest && !e.target.closest('.wx-links')) return;

    const viewport = e.target.closest('.wx-gantt');
    if (!viewport) return;

    const { scrollLeft } = apiRef.current.getState();
    panRef.current = {
      x: e.clientX,
      y: e.clientY,
      left: scrollLeft || 0,
      top: viewport.scrollTop,
      viewport,
      id: e.pointerId,
      active: false,
    };
  };

  const onPointerMove = (e) => {
    const pan = panRef.current;
    if (!pan) return;

    const dx = e.clientX - pan.x;
    const dy = e.clientY - pan.y;

    if (!pan.active) {
      if (Math.abs(dx) < PAN_THRESHOLD && Math.abs(dy) < PAN_THRESHOLD) return;
      pan.active = true;
      boardRef.current.setPointerCapture(pan.id);
    }

    // Нативный скролл ограничивает позицию границами; SVAR синхронизирует таблицу по scroll.
    pan.viewport.scrollTop = pan.top - dy;
    apiRef.current.exec('scroll-chart', { left: pan.left - dx });
  };

  const onPointerUp = () => {
    const pan = panRef.current;
    if (!pan) return;

    if (pan.active) boardRef.current.releasePointerCapture(pan.id);
    panRef.current = null;
  };

  return { onPointerDown, onPointerMove, onPointerUp };
};

export default useChartPan;
